import "../styles/agb.css";

export default function AGB() {
  return (
    <div className="agb-container">
      <h1>
        <strong>Allgemeine Geschäftsbedingungen (AGB)</strong>
      </h1>

      <p>der ReYou UG (haftungsbeschränkt)</p>
      <p>
        <strong>Stand:</strong> Februar 2026
      </p>

      <section>
        <h3>§ 1 Geltungsbereich</h3>
        <p>
          (1) Diese AGB gelten für alle Verträge zwischen der ReYou UG
          (haftungsbeschränkt), Mündelheimer Weg 31, 40472 Düsseldorf, vertreten
          durch die Geschäftsführung (nachfolgend „ReYou“), und ihren Kunden über
          die Nutzung der digitalen Plattform „RIYU“ sowie zugehöriger Messenger-,
          Web- und App-Dienste.
        </p>
        <p>
          (2) ReYou richtet sich primär an Verbraucher (§ 13 BGB). Sofern
          Unternehmer (§ 14 BGB) Leistungen nutzen, gelten ergänzend die in § 15
          geregelten Sonderbestimmungen.
        </p>
      </section>

      <section>
        <h3>§ 2 Vertragsgegenstand</h3>
        <p>
          (1) ReYou stellt eine KI-gestützte digitale Plattform zur Verfügung,
          die personalisierte Ernährungs- und Alltagsvorschläge generiert.
        </p>
        <p>
          (2) Die Leistungen bestehen ausschließlich in der Bereitstellung
          digitaler Inhalte und digitaler Dienstleistungen im Sinne der §§ 327
          ff. BGB.
        </p>
        <p>(3) ReYou schuldet keinen bestimmten gesundheitlichen, körperlichen oder sonstigen Erfolg.</p>
      </section>

      <section>
        <h3>§ 3 Vertragsschluss</h3>
        <p>
          (1) Der Vertrag kommt durch Abschluss des elektronischen
          Bestellvorgangs und Klick auf die Schaltfläche „zahlungspflichtig
          bestellen" zustande.
        </p>
        <p>(2) Bei kostenfreien Testzugängen kommt der Vertrag mit Registrierung zustande.</p>
        <p>
          (3) ReYou stellt dem Kunden nach Vertragsschluss eine Bestätigungs-E-Mail
          zu, die den Vertragstext einschließlich dieser AGB enthält. Zusätzlich
          sind diese AGB jederzeit unter reyou.ai/agb abrufbar und können dort
          gespeichert und ausgedruckt werden.
        </p>
      </section>

      <section>
        <h3>§ 4 Widerrufsrecht für Verbraucher</h3>
        <p>
          (1) Verbrauchern steht ein gesetzliches Widerrufsrecht von 14 Tagen zu.
          Die vollständige Widerrufsbelehrung gemäß Art. 246a EGBGB ist dieser
          AGB als Anlage 1 beigefügt und Bestandteil des Vertrages.
        </p>
        <p>(2) Bei digitalen Inhalten erlischt das Widerrufsrecht vorzeitig, wenn:</p>
        <ul>
          <li>der Kunde ausdrücklich zustimmt, dass ReYou vor Ablauf der Widerrufsfrist mit der Ausführung beginnt,</li>
          <li>der Kunde bestätigt, dass ihm bewusst ist, dass er dadurch sein Widerrufsrecht verliert,</li>
          <li>und ReYou mit der Vertragsausführung begonnen hat.</li>
        </ul>
        <p>(3) Unternehmern steht kein Widerrufsrecht zu.</p>
      </section>

      <section>
        <h3>§ 5 Leistungsumfang und Verfügbarkeit</h3>
        <p>(1) Der konkrete Leistungsumfang ergibt sich aus der jeweiligen Leistungsbeschreibung des gewählten Abonnement-Plans.</p>
        <p>
          (2) ReYou ist berechtigt, Funktionen weiterzuentwickeln, anzupassen oder
          zu ändern, soweit hierdurch der Kernleistungsumfang nicht wesentlich
          beeinträchtigt wird.
        </p>
        <p>
          (3) Eine bestimmte Verfügbarkeit wird nicht garantiert. Wartungsarbeiten
          können zu vorübergehenden Einschränkungen führen. ReYou bemüht sich um
          eine hohe Verfügbarkeit der Plattform.
        </p>
      </section>

      <section>
        <h3>§ 6 Abonnement, Laufzeit und Kündigung</h3>
        <p>
          (1) Abonnements werden auf unbestimmte Zeit geschlossen und sind in
          einem monatlichen oder jährlichen Abrechnungszeitraum erhältlich.
        </p>
        <p>
          (2) Eine Kündigung ist jederzeit mit Wirkung zum Ende des jeweiligen
          laufenden Abrechnungszeitraums möglich. Bei monatlichen Abonnements ist
          dies das Ende des laufenden Kalendermonats; bei jährlichen Abonnements
          das Ende des laufenden Abonnementjahres.
        </p>
        <p>
          (3) Kündigungen können über die Account-Verwaltung oder per E-Mail an{" "}
          <a href="mailto:support@reyou.ai">support@reyou.ai</a> erfolgen.
        </p>
        <p>(4) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>
      </section>

      <section>
        <h3>§ 7 Preise und Zahlungsbedingungen</h3>
        <p>
          (1) Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise. Alle
          Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.
        </p>
        <p>(2) Die Abrechnung erfolgt im Voraus, jeweils zu Beginn des Abrechnungszeitraums.</p>
        <p>
          (3) Im Falle des Zahlungsverzugs gelten die gesetzlichen Verzugszinsen
          (§ 288 BGB). Dem Kunden bleibt der Nachweis eines geringeren Schadens
          vorbehalten.
        </p>
      </section>

      <section>
        <h3>§ 8 Nutzungspflichten</h3>
        <p>(1) Der Zugang ist personalisiert und darf nicht an Dritte weitergegeben werden.</p>
        <p>(2) Es ist untersagt:</p>
        <ul>
          <li>automatisierte Abfragen vorzunehmen,</li>
          <li>Reverse Engineering zu betreiben,</li>
          <li>technische Schutzmaßnahmen zu umgehen.</li>
        </ul>
        <p>(3) Bei Verstößen gegen diese Nutzungspflichten geht ReYou wie folgt vor:</p>
        <ul>
          <li>Stufe 1 – Verwarnung: Der Nutzer wird schriftlich (per E-Mail) auf den Verstoß hingewiesen und zur Unterlassung aufgefordert.</li>
          <li>Stufe 2 – Temporäre Sperrung: Bei Wiederholung oder ausbleibender Reaktion kann der Account vorübergehend gesperrt werden.</li>
          <li>Stufe 3 – Permanente Sperrung und Kündigung: Bei fortgesetzten oder besonders schwerwiegenden Verstößen ist ReYou berechtigt, den Account dauerhaft zu sperren und das Vertragsverhältnis außerordentlich zu kündigen.</li>
        </ul>
        <p>
          (4) Bei unmittelbar drohenden Schäden für ReYou oder Dritte – insbesondere
          bei Cyberangriffen, schwerwiegenden Datenschutzverstößen oder strafbaren
          Handlungen – ist ReYou berechtigt, den Account ohne vorherige Warnung
          sofort zu sperren.
        </p>
      </section>

      <section>
        <h3>§ 9 Medizinische und inhaltliche Abgrenzung</h3>
        <p>(1) ReYou stellt keine medizinische Beratung, Diagnose oder Therapie dar.</p>
        <p>(2) Die bereitgestellten Inhalte ersetzen keinen Arztbesuch und sind nicht als Heilmittel oder medizinische Intervention zu verstehen.</p>
        <p>(3) Empfehlungen erfolgen auf Grundlage algorithmischer Auswertung und können unvollständig oder fehlerhaft sein.</p>
        <p>(4) Nutzer sind verpflichtet, bei bestehenden Erkrankungen vor Ernährungsumstellungen ärztlichen Rat einzuholen.</p>
      </section>

      <section>
        <h3>§ 10 KI-Systeme, algorithmische Entscheidungsfindung und EU AI Act</h3>
        <p>
          (1) ReYou verwendet KI-Modelle und automatisierte Entscheidungsprozesse
          (u. a. von OpenAI, Anthropic sowie eigene Modelle) zur Generierung
          personalisierter Inhalte.
        </p>
        <p>
          (2) Die Vorschläge basieren auf vom Nutzer bereitgestellten Daten sowie
          auf Trainingsdaten Dritter. Es wird keine Gewähr für die inhaltliche
          Richtigkeit, Vollständigkeit oder Zielerreichung übernommen.
        </p>
        <p>
          (3) ReYou klassifiziert das eingesetzte KI-System nach dem EU AI Act
          (Verordnung (EU) 2024/1689) derzeit als KI-System mit geringem Risiko.
          Eine Einstufung als Hochrisiko-KI-System im Sinne von Anhang III der
          Verordnung liegt nach aktuellem Stand nicht vor. ReYou überprüft diese
          Einstufung regelmäßig.
        </p>
        <p>
          (4) Recht auf menschliche Überprüfung: Nutzer haben das Recht, bei für
          sie bedeutsamen KI-gestützten Vorschlägen eine menschliche Überprüfung
          zu beantragen. Entsprechende Anfragen können an{" "}
          <a href="mailto:support@reyou.ai">support@reyou.ai</a> gerichtet werden.
        </p>
        <p>
          (5) ReYou stellt auf Anfrage allgemeine Informationen zur Funktionsweise
          der eingesetzten KI-Systeme bereit, soweit dies technisch und aus Gründen
          des Schutzes von Geschäftsgeheimnissen möglich ist.
        </p>
      </section>

      <section>
        <h3>§ 11 Haftung</h3>
        <p>
          <strong>(1) ReYou haftet unbeschränkt:</strong>
        </p>
        <ul>
          <li>bei Vorsatz und grober Fahrlässigkeit,</li>
          <li>bei Verletzung von Leben, Körper oder Gesundheit,</li>
          <li>nach dem Produkthaftungsgesetz,</li>
          <li>bei Übernahme einer Garantie.</li>
        </ul>
        <p>
          (2) Bei leichter Fahrlässigkeit haftet ReYou nur bei Verletzung wesentlicher
          Vertragspflichten (Kardinalpflichten) und beschränkt auf den typischerweise
          vorhersehbaren Schaden.
        </p>
        <p>(3) Eine weitergehende Haftung ist ausgeschlossen.</p>
      </section>

      <section>
        <h3>§ 12 Gewährleistung bei digitalen Produkten</h3>
        <p>(1) Es gelten die gesetzlichen Vorschriften der §§ 327 ff. BGB.</p>
        <p>(2) Verbraucher haben die gesetzlichen Mängelrechte.</p>
        <p>(3) Unternehmern gegenüber beträgt die Verjährungsfrist für Mängel ein Jahr.</p>
      </section>

      <section>
        <h3>§ 13 Datenschutz</h3>
        <p>
          (1) Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutz-Grundverordnung
          (DSGVO) und dem Bundesdatenschutzgesetz (BDSG). Details ergeben sich aus
          der gesonderten Datenschutzerklärung, die unter reyou.ai/datenschutz abrufbar ist.
        </p>
        <p>(2) ReYou setzt Auftragsverarbeiter ein. Dies umfasst insbesondere die folgenden Kategorien:</p>
        <ul>
          <li>KI-Dienstleister (u. a. OpenAI, L.L.C., USA; Anthropic, PBC, USA; eigene Modelle auf externen Hosting-Infrastrukturen),</li>
          <li>Zahlungsdienstleister,</li>
          <li>Hosting- und Cloud-Anbieter,</li>
          <li>E-Mail- und Kommunikationsdienstleister.</li>
        </ul>
        <p>
          (3) Bei der Nutzung von KI-Dienstleistern mit Sitz in den USA erfolgt die Datenübermittlung
          auf Grundlage von Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO oder anderer
          geeigneter Garantien. Details hierzu finden sich in der Datenschutzerklärung.
        </p>
      </section>

      <section>
        <h3>§ 14 Änderungen der AGB</h3>
        <p>
          (1) ReYou kann diese AGB anpassen, wenn hierfür ein sachlicher Grund besteht
          (z. B. Gesetzesänderungen, technische Änderungen, neue Produktfunktionen).
        </p>
        <p>
          (2) Kunden werden über Änderungen mindestens vier Wochen vor Inkrafttreten per E-Mail informiert.
          Die Änderungen gelten als genehmigt, wenn der Kunde nicht innerhalb von vier Wochen nach Zugang
          der Mitteilung widerspricht. ReYou wird in der Mitteilung auf diesen Umstand ausdrücklich hinweisen.
        </p>
        <p>
          (3) Bei wesentlichen Änderungen steht dem Kunden ein Sonderkündigungsrecht zu, das bis zum
          Inkrafttreten der Änderung ausgeübt werden kann.
        </p>
      </section>

      <section>
        <h3>§ 15 Sonderregelungen für Unternehmer</h3>
        <p>(1) Gegenüber Unternehmern gilt als ausschließlicher Gerichtsstand der Sitz von ReYou.</p>
        <p>(2) Es gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts (CISG).</p>
      </section>

      <section>
        <h3>§ 16 Online-Streitbeilegung und Verbraucherstreitschlichtung</h3>
        <p>
          (1) Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit,
          die unter https://ec.europa.eu/consumers/odr erreichbar ist.
        </p>
        <p>
          (2) ReYous E-Mail-Adresse lautet: <a href="mailto:support@reyou.ai">support@reyou.ai</a>.
        </p>
        <p>
          (3) ReYou ist nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen (§ 36 VSBG).
        </p>
      </section>

      <section>
        <h3>§ 17 Schlussbestimmungen</h3>
        <p>(1) Vertragssprache ist Deutsch.</p>
        <p>
          (2) Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam oder undurchführbar sein
          oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
        </p>
        <p>
          (3) Es gilt das Recht der Bundesrepublik Deutschland. Für Verbraucher gilt dies nur insoweit,
          als nicht zwingende Vorschriften des Rechts des Staates, in dem der Verbraucher seinen gewöhnlichen
          Aufenthalt hat, entgegenstehen.
        </p>
      </section>

      <section>
        <h3>Anlage 1 – Widerrufsbelehrung</h3>

        <h4>Widerrufsrecht</h4>
        <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
        <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.</p>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (ReYou UG (haftungsbeschränkt), Mündelheimer Weg 31,
          40472 Düsseldorf, E-Mail: <a href="mailto:support@reyou.ai">support@reyou.ai</a>) mittels einer eindeutigen
          Erklärung (z. B. ein per Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu
          widerrufen, informieren.
        </p>
        <p>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts
          vor Ablauf der Widerrufsfrist absenden.
        </p>

        <h4>Folgen des Widerrufs</h4>
        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
          einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine
          andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich
          und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses
          Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
          ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart;
          in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>

        <h4>Erlöschen des Widerrufsrechts bei digitalen Inhalten</h4>
        <p>
          Ihr Widerrufsrecht erlischt vorzeitig, wenn wir mit der Ausführung des Vertrags begonnen haben, nachdem Sie
          ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen,
          und Sie Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags
          Ihr Widerrufsrecht verlieren.
        </p>

        <h4>Muster-Widerrufsformular</h4>
        <p>
          <em>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</em>
        </p>

        <p>
          An: ReYou UG (haftungsbeschränkt), Mündelheimer Weg 31, 40472 Düsseldorf,{" "}
          <a href="mailto:support@reyou.ai">support@reyou.ai</a>
        </p>

        <p>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Dienstleistung (*): _______________
        </p>
        <p>Bestellt am (*): _______________</p>
        <p>Name des/der Verbraucher(s): _______________</p>
        <p>Anschrift des/der Verbraucher(s): _______________</p>
        <p>Datum: _______________</p>

        <p>
          <em>(*) Unzutreffendes streichen.</em>
        </p>
      </section>
    </div>
  );
}